import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { ClientPortalProviders } from 'ClientPortal/src/App'
import { configureAmplify } from 'ComponentLibrary'
import { RouterProvider } from 'react-router-dom'
import { router } from 'ClientPortal/src/router/ClientPortalRouter'
import * as Sentry from '@sentry/react'
import 'katex/dist/katex.min.css'
import './katexCustom.css'
import { browserTracingIntegration } from '@sentry/browser'

import { pdfjs } from 'react-pdf'
import invariant from 'tiny-invariant'
import { bootstrapClientPortalCcm } from 'ClientPortal/src/consent/clientPortalCcm'

void (async () => {
    pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString()
    bootstrapClientPortalCcm()
    configureAmplify()
    if (import.meta.env['VITE_SENTRY_ENABLED'] === 'true') {
        Sentry.init({
            dsn: import.meta.env['VITE_SENTRY_DSN'],
            integrations: [browserTracingIntegration()],
            tracesSampleRate: 0.05,
            environment: import.meta.env['VITE_ENV'],
        })
    }

    const container = document.getElementById('root')
    invariant(container, 'Root element not found')
    const root = createRoot(container)
    root.render(
        <React.StrictMode>
            <ClientPortalProviders>
                <RouterProvider router={router} />
            </ClientPortalProviders>
        </React.StrictMode>
    )
})()
